const formatInventories = items => items
  .reduce((prev, curr) => {
    if (curr.inventory) {
      let message = 'In Stock'
      if (curr.inventory.quantity < 6) {
        let unitsLeft = 'Units Left'
        if (curr.inventory.quantity === 1) {
          unitsLeft = 'Unit Left'
        }
        message = `${curr.inventory.quantity} ${unitsLeft}`
      }
      const count = curr.inventory.quantity > 50 ? 50 : curr.inventory.quantity
      return {
        ...prev,
        [curr.product.productId]: {
          available: curr.inventory.quantity > 0,
          count,
          message,
          dropCount: count,
          isFreeShipping: curr.inventory.shipping.type === 'Free',
        },
      }
    }

    return {
      ...prev,
      [curr.product.productId]: {
        available: true,
        count: 50,
        message: false,
        dropCount: 50,
        isFreeShipping: false,
      },
    }
  },
  {}) || {}

export default formatInventories
